<script>
export default {
  name: "TemplateListButton",
  props: {
    label: { type: String, default: "テンプレート一覧" },
    btnClass: { type: String, default: "btn" },
    type: { type: String, default: "button" },
  },
  methods: {
    handleClick(event) {
      this.$emit("click", event);
    },
  },
};
</script>

<template>
  <button :type="type" :class="btnClass" @click="handleClick">
    {{ label }}
  </button>
</template>

<style scoped>
</style>